import { render, staticRenderFns } from "./students.vue?vue&type=template&id=380c11d3&scoped=true&"
import script from "./students.vue?vue&type=script&lang=ts&"
export * from "./students.vue?vue&type=script&lang=ts&"
import style0 from "./students.vue?vue&type=style&index=0&id=380c11d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380c11d3",
  null
  
)

export default component.exports